<template>
    <div class="checker-detail-row">
        <div
            v-for="slot in ['left', 'right', 'default']"
            v-if="$slots[slot]"
            :key="slot"
            :class="`checker-detail-${slot}`"
        >
            <slot :name="slot"/>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'checker-detail-row',
    };
</script>

<style lang="less" scoped>
    @import "~bootstrap/less/mixins/clearfix";

    .checker-detail-row {
        border-bottom: 1px solid #e7e7e7;
        padding: 15px 10px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > div {
            &.checker-detail-default {
                flex-grow: 1;

                .picker__input {
                    cursor: pointer;
                }
            }

            &.checker-detail-left,
            &.checker-detail-right {
                width: 50%;
            }

            &.checker-detail-left {
                font-weight: bold;
                flex-grow: 1;
            }

            &.checker-detail-right {
                text-align: right;
                font-weight: normal;
            }
        }
    }
</style>
